import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { RespuestaValidaPago } from 'src/app/global/enums/respuesta-valida-pago.enum';
import { FirmasFaltante } from 'src/app/global/interfaces/anexo-contrato-response';
import { MensajeDTO } from 'src/app/global/interfaces/general-response';
import { DialogDataThree } from 'src/app/global/models/dialog/dialog-data-three';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { modalMessagesStep3 } from 'src/app/messages/step-3-modals';
import { FirmaServiceVM } from 'src/app/view-model/services/firma.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { SiguientesPasosServiceVM } from 'src/app/view-model/services/siguientes-pasos-vm.service';
import { ValidacionEdicionServiceVM } from 'src/app/view-model/services/validacion-edicion.service';
import { environment } from '../../../../environments/environment';

const env = environment;

interface ValidaFirmaResponse {
  text: string;
  status: boolean;
}

@Component({
  selector: 'app-spinner-retur-external',
  templateUrl: './spinner-retur-external.component.html',
  styleUrls: ['./spinner-retur-external.component.scss']
})
export class SpinnerReturExternalComponent implements OnInit {

  private THIRD_STEP_URL = '/?action=retoma';
  private ERROR_PAGE_URL = '/error-pago';
  private GENERATION_PROCESS = 'generacion-proceso';

  private RESPUESTA_INCORRECTAS: ValidaFirmaResponse = { text: 'Respuestas Incorrectas', status: false };
  private NO_AUTORIZADO: ValidaFirmaResponse = { text: 'No autorizado', status: false };
  private DOCUMENTO_FIRMADO: ValidaFirmaResponse = { text: 'Documento Firmado', status: true };

  


  constructor(
    private productService: vmProductosService,
    private route: ActivatedRoute,
    private router: Router,
    private firmaServiceVM: FirmaServiceVM,
    private valEdicionService: ValidacionEdicionServiceVM,
    private localStorageService: LocalStorageService,
    private sigPasosService: SiguientesPasosServiceVM
  ) { }

  async ngOnInit() {
    this.validStepThree();
    await this.productService.cargaSeleccionActualEnCarro().toPromise();
    const origen = this.route.snapshot.paramMap.get('origen');
    const codigoRespuesta = (this.route.snapshot.paramMap.get('codigoRespuesta')) ? this.route.snapshot.paramMap.get('codigoRespuesta') : '';
    await this.edit();


    (origen === 'portalpago') ? this.validPay() : this.validateSignature(codigoRespuesta);
  }

  private validStepThree() {
    const stepThree = this.localStorageService.getPaso3();
    if (!stepThree) {
      this.router.navigate(['/']);
    }
  }

  private async edit() {
    const validStepThree: any = await this.valEdicionService.getValidacionEdicion().toPromise();
    const stepThreeLocalStore = this.localStorageService.getPaso3();
    stepThreeLocalStore.validaPaso3 = validStepThree;
    this.localStorageService.setPaso3(stepThreeLocalStore);
  }

  private async validPay() {
    await this.getProducto();
    const validPay = await this.productService.validaPagoProducto();
    if (RespuestaValidaPago.CONTINUAR_RESUMEN === validPay) {
      const pasos = await this.sigPasosService.obtenerSiguientesPasos().toPromise();
      const dataPaso3 = this.localStorageService.getPaso3();
      dataPaso3.siguientePaso = pasos;
      this.localStorageService.setPaso3(dataPaso3);
      this.redirect(this.GENERATION_PROCESS);
    } else {
      this.redirect(this.ERROR_PAGE_URL);
    }
  }

  private async validateSignature(codigoRespuesta: string) {
    const paso3LS = this.localStorageService.getPaso3();
    const lstFirmantes = (paso3LS.lstFirmadores) ? paso3LS.lstFirmadores : [];
    let firmante: FirmasFaltante = null;
    let status : MensajeDTO;
    try {
      status = await this.firmaServiceVM.validStatusFirm(codigoRespuesta);
      if (status.titulo === this.DOCUMENTO_FIRMADO.text) {
        firmante = paso3LS.firmador;
        firmante.status = this.DOCUMENTO_FIRMADO.status;
        paso3LS.errorFirma = null;
      } else {
        firmante = null;
        paso3LS.errorFirma = this.textDialog(status);
      }
    } catch (ex) {
      console.error('Error on validate signature', ex);
      status = ex.error.mensaje;
      paso3LS.errorFirma = this.textDialog(status);
    }

    const newFirmantes: Array<FirmasFaltante> = (firmante) ? this.armarListFirmantes(lstFirmantes, firmante) : [...lstFirmantes];
    paso3LS.firmador = firmante;
    paso3LS.lstFirmadores = newFirmantes;

    console.error(`paso3LS.errorFirma`, paso3LS.errorFirma);

    this.localStorageService.setPaso3(paso3LS);
    localStorage.removeItem('token');
    localStorage.removeItem('run');
    localStorage.removeItem('origen');
    localStorage.removeItem('C');
    localStorage.setItem('spinner', 'true');
    localStorage.removeItem('modal');

    this.localStorageService.setCurrentPage(_.get(env, 'localStorage.PASO_3', ''));
    console.log(localStorage);
    this.router.navigate([this.THIRD_STEP_URL]);
  }

  private textDialog(responseService): DialogDataThree {
    let dialogDataThree: DialogDataThree;

    if (responseService !== null && responseService.titulo === this.RESPUESTA_INCORRECTAS.text) {
      dialogDataThree = {
        title: 'No se pudo verificar identidad',
        subTitle: 'Las respuestas ingresadas no son correctas',
        description: responseService.contenido,
        //'Tiene un máximo de tres intentos, posterior a esto se bloqueará tu posibilidad de firmas por 24 horas',
        textFirstBtn: 'Volver',
        textSecondBtn: 'Firmar',
        disableSecondBtn: false
      };
    } else if(responseService !== null && responseService.titulo === this.NO_AUTORIZADO.text){
      dialogDataThree = {
        title: modalMessagesStep3.SIGNATURE_ERROR_TITLE,
        subTitle: modalMessagesStep3.SIGNATURE_ERROR_DESCRIPTION,
        description: modalMessagesStep3.SIGNATURE_ERROR_DESCRIPTION,
        textFirstBtn: modalMessagesStep3.SIGNATURE_ERROR_BUTTON_OK,
        textSecondBtn: 'Firmar',
        disableSecondBtn: true
      };
    } else {
      dialogDataThree = {
        title: 'No se pudo verificar identidad',
        subTitle: 'Las respuestas ingresadas no son correctas',
        description: 'Ya ha intentos el máximo de vez permitido, su firma digital se bloqueará por las próximas 24 horas',
        textFirstBtn: 'Volver',
        textSecondBtn: 'Firmar',
        disableSecondBtn: true
      };
    }
    return dialogDataThree;
  }


  private armarListFirmantes(lstStore, firmante): Array<FirmasFaltante> {
    const newLstFirmante: Array<FirmasFaltante> = lstStore.filter(firmanteStore => firmanteStore.run != firmante);
    return newLstFirmante;
  }


  private redirect(url: string) {
    this.router.navigate([url]);
  }

  private async getProducto() {
    await this.productService.cargaSeleccionActualEnCarro().toPromise();
  }

}
